import React from 'react'
import { TextInput } from 'SRC/ui/FormElements'
import config from 'SRC/config/config.yaml'

const confirmPasswordField = {
  id: 'confirmPassword',
  name: 'confirmPassword',
  type: 'password',
  label: config.updateProfileForm.password.newPasswordRepeat,
  isRequired: true
}

export const ConfirmPassword = () =>
  <TextInput {...confirmPasswordField} />
